$(function () {
    var classifications = [];

    var classificationCategory = {
        links: document.querySelectorAll('[data-media-filter-value]'),
        hiddenElement: $("#hdn-available-categories"),
        id: "cid",
    };

    var classificationTaxonomy = {
        links: document.querySelectorAll('[data-media-filter-value2]'),
        hiddenElement: $("#hdn-available-taxonomies"),
        id: "tid",
    };

    classifications.push(classificationTaxonomy);
    classifications.push(classificationCategory);

    classifications.forEach((elem) => {

        if (elem.links.length === 0 || elem.hiddenElement.length === 0 || elem.hiddenElement.val() === "") {
            return;
        }

        try {
            let ids = JSON.parse(elem.hiddenElement.val());
            for (var i = 0; i < elem.links.length; i++) {
                let tid = $(elem.links[i]).data(elem.id);
                if (tid !== "00000000-0000-0000-0000-000000000000" && !ids.includes(tid)) {
                    $(elem.links[i]).removeClass();
                    $(elem.links[i]).hide();
                }
            }
        }
        catch (e) {
            console.log(e);
        }
    })
});